import React, { useEffect, useCallback } from "react";
import { Modal, Box, Typography } from "@mui/material";

import dealerCareApi from "services/dealerCareApi";

import { Terms, useAuth } from "context/AuthContext";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "70vh",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  p: 3,
  width: 300,
};

interface TermsModalOperatorProps {
  visible: boolean;
}

const TermsModalOperator = ({ visible }: TermsModalOperatorProps) => {
  const { profileData, updateTerms } = useAuth();

  const handleGetDealerInfo = useCallback(async (): Promise<Terms> => {
    const { data } = await dealerCareApi.get(
      `v1/dealers/${profileData.dealerId}`,
    );

    updateTerms(data.data.termsOfService);

    return data.data.termsOfService;
  }, [profileData.dealerId, updateTerms]);

  useEffect(() => {
    if (visible) handleGetDealerInfo();
  }, [visible, handleGetDealerInfo]);

  return (
    <Modal open={visible}>
      <Box sx={modalStyle}>
        <Typography variant="h6" component="h2" gutterBottom>
          Atenção
        </Typography>

        <Typography variant="body2">
          Para continuar a acessar o Portal é necessário que o administrador
          desta conta aceite os novos Termos e Condições disponíveis para ele ao
          entrar no Portal.
        </Typography>
      </Box>
    </Modal>
  );
};

export default TermsModalOperator;
